var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tax_event_row",on:{"click":function($event){return _vm.edit_tax_event()}}},[_c('div',[_c('span',[_vm._v("Tax event id "+_vm._s(_vm.tax_event.event_id))]),_c('span',[_vm._v(", "+_vm._s(_vm.status))]),_c('span',[_vm._v(", created "+_vm._s(_vm.created_on))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }